import {AxiosInstance} from "axios";

export default class SiteApi {
	constructor(public readonly axiosInstance: AxiosInstance) {}

	async uploadAttachment(siteId: number, fileName: string, base64Data: string): Promise<void> {
		const url = `/api/companies/site/${siteId}`;
		await this.axiosInstance.post(url, {fileName, base64Data});
	}
}
